export default "__VITE_ASSET__39210019__"